import { jsx as e } from "react/jsx-runtime";
import { useStyleConfig as n } from "@chakra-ui/react";
import { MagicFilledIcon as a } from "../../icons/index.es.js";
const s = ({
  animated: t = !1,
  ...i
}) => {
  const o = n("MagicAnimatedIcon");
  return /* @__PURE__ */ e(a, { "data-animated": String(t), sx: o, ...i });
};
export {
  s as MagicAniamtedFilledIcon
};
//# sourceMappingURL=MagicAniamtedFilledIcon.es.js.map
